import { clientConfig } from "../config/clientConfig";
import { MODULES, ModuleName } from "../config/modules";

export const hasModule = (moduleName: ModuleName | string): boolean => {
  // In the future, this can be updated to use an API response context
  // e.g., return apiContext.modules[moduleName] ?? false;
  
  const modules = clientConfig.modules as Record<string, boolean>;
  if (moduleName === MODULES.AI_ADOPTION || moduleName === MODULES.DASHBOARD) {
    if (modules[MODULES.AI_ADOPTION] !== undefined) return !!modules[MODULES.AI_ADOPTION];
    if (modules[MODULES.DASHBOARD] !== undefined) return !!modules[MODULES.DASHBOARD];
  }
  return !!modules[moduleName];
};
